import { render } from "./ParticipantsDisplay.vue?vue&type=template&id=0e8f3499"
import script from "./ParticipantsDisplay.vue?vue&type=script&lang=ts"
export * from "./ParticipantsDisplay.vue?vue&type=script&lang=ts"
script.render = render

export default script